import { SagaIterator } from '@redux-saga/core';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { workerFetchAgenciesSaga, workerSetStatusAgencies } from './workers';
import { fetchAgencies, setStatusAgenciesAction } from '../reducer';

export default function* watchAgencies(): SagaIterator {
  yield takeEvery(fetchAgencies, workerFetchAgenciesSaga);
  yield takeLatest(setStatusAgenciesAction, workerSetStatusAgencies);
}
